<template>
    <div id="projectAdd">
        <div class="con">
            <img class="imgborder" src="../../assets/project/add-border.png" alt="">
            <div class="details">
                <div class="close" @click="close">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/project/project-left.png" alt="">
                    <span class="text">项目管理</span>
                    <img src="../../assets/project/project-right.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
                <div class="content">
                    <div class="content-item">
                        <div class="top">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" :validate-on-rule-change="false">
                                <div style="display:flex;justify-content: space-between;">
                                    <el-form-item prop="projectname" style="width: 30%;" >
                                        <div class="project-add-header">项目名称</div>
                                        <el-input placeholder="请输入项目名称" v-model="ruleForm.projectname" style="width:227px;" :disabled="isAssign" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="area" style="width: 30%;">
                                        <div class="project-add-header">项目总量</div>
                                        <el-input @change="areaChange" placeholder="请输入项目总量" v-model.number="ruleForm.area" :disabled="isAssign" style="width:227px;" clearable id="areaInput"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="money" style="width: 30%;">
                                        <div class="project-add-header">项目金额(万元)</div>
                                        <el-input :disabled="true" @change="moneyChange" placeholder="请输入项目金额" v-model="ruleForm.money" style="width:227px;" clearable></el-input>
                                    </el-form-item>
                                </div>
                                <div style="display:flex;justify-content: space-between;">
                                    <el-form-item prop="startTime" style="width: 30%;" >
                                        <div class="project-add-header">开始时间</div>
                                        <el-date-picker style="width:227px;" :disabled="isAssign" v-model="ruleForm.startTime" type="date" placeholder="请选择开始时间" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="startTimeStatus" clearable> </el-date-picker>
                                    </el-form-item>
                                    <el-form-item prop="endTime" style="width: 30%;">
                                        <div class="project-add-header">结束时间</div>
                                        <el-date-picker style="width:227px;" :disabled="isAssign" v-model="ruleForm.endTime" type="date" placeholder="请选择结束时间" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="endTimeStatus" clearable> </el-date-picker>
                                    </el-form-item>
                                    <el-form-item prop="radio" style="width: 30%;">
                                        <div class="project-add-header">全程托管</div>
                                        <el-select v-model="ruleForm.radio" :disabled="isAssign" style="width:227px;" placeholder="请选择是否全程托管" clearable>
                                            <el-option label="是" value=true></el-option>
                                            <el-option label="否" value=false></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div style="display:flex;justify-content: flex-start;">
                                    <el-form-item prop="principalName" style="width: 30%;" >
                                        <div class="project-add-header">负责人</div>
                                        <el-input placeholder="请输入负责人名称" v-model="ruleForm.principalName" style="width:227px;"  maxlength="4" :disabled="isAssign" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="principalPhone" style="width: 30%;margin-left: 5%" >
                                        <div class="project-add-header">联系方式</div>
                                        <el-input placeholder="请输入联系方式" v-model.number="ruleForm.principalPhone" style="width:227px;" maxlength="11" :disabled="isAssign" clearable></el-input>
                                    </el-form-item>
                                </div>
                                <div style="">
                                    <div class="project-add-header">
                                        作业类型(可多选)
                                        <img style="width:16px;vertical-align: middle;" @click="moduleAdd" src="../../assets/project/add-icon.png" alt="">
                                        <img style="width:16px;vertical-align: middle;margin-left:5px;"  @click="moduleDel()" src="../../assets/project/delete-icon.png" alt="">
                                    </div>
                                    <el-table :data="ruleForm.moduleData" @selection-change="moduleSelectionChange" ref="moduleMultipleTable" :row-style="{height:'40px'}" :header-row-style="{height:'40px'}" :cell-style="{padding:'0px'}" :header-cell-style="{textAlign: 'center'}">
                                        <el-table-column type="selection" width="55" align="center">
                                        </el-table-column>
<!--                                        <el-table-column label="序号" type="index" align="center">-->
<!--                                        </el-table-column>-->
                                        <el-table-column label="作业类型" style="width:200" align="center">
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'moduleData.' + scope.$index + '.workTypeId'" :rules="rules.workTypeId">
                                                    <el-select filterable style="width:100%;" :disabled="isAssign" v-model="ruleForm.moduleData[scope.$index].workTypeId" placeholder="请选择作业类型" @change="selectModule" clearable >
                                                        <el-option v-for="item in moduleData" :key="item.id" :label="item.name" :value="item.id" :disabled="item.disabled">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :label="labelText" style="width:100" align="center">
                                            <template slot-scope="scope">
                                                <el-form-item style="margin-left:10px;" :disabled="isAssign" :prop="'moduleData.' + scope.$index + '.subsidyAmount'" :rules="rules.subsidyAmount">
                                                    <el-input @change='priceChange(ruleForm.moduleData[scope.$index].index,ruleForm.moduleData[scope.$index].subsidyAmount)' v-model.number="ruleForm.moduleData[scope.$index].subsidyAmount" placeholder="请输入单价" clearable></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div style="">
                                    <div class="project-add-header">
                                        参与单位(可多选)
                                        <img style="width:16px;vertical-align: middle;" @click="add" src="../../assets/project/add-icon.png" alt="">
                                        <img style="width:16px;vertical-align: middle;margin-left:5px;"  @click="delArray()" src="../../assets/project/delete-icon.png" alt="">
                                    </div>
                                    <el-table :data="ruleForm.tableData" @selection-change="handleSelectionChange" ref="multipleTable" :row-style="{height:'40px'}" :header-row-style="{height:'40px'}" :cell-style="{padding:'0px'}" :header-cell-style="{textAlign: 'center'}">
                                        <el-table-column type="selection" width="55" align="center">
                                        </el-table-column>
<!--                                        <el-table-column label="序号" type="index" align="center">-->
<!--                                        </el-table-column>-->
                                        <el-table-column label="参与单位" style="width:200" align="center">
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'tableData.' + scope.$index + '.userId'" :rules="rules.userId">
                                                    <el-select filterable v-model="ruleForm.tableData[scope.$index].userId"  placeholder="请选择参与单位" @change="selectGetunitName()" clearable>
                                                        <el-option v-for="item in unitName" :key="item.userId" :label="item.name" :value="item.userId" :disabled="item.disabled">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="分配任务" style="width:100" align="center">
                                            <template slot-scope="scope">
                                                <el-form-item style="margin-left:10px;" :prop="'tableData.' + scope.$index + '.allocatedArea'" :rules="rules.allocatedArea">
                                                    <el-input @change='inputChange(ruleForm.tableData[scope.$index].index,ruleForm.tableData[scope.$index].allocatedArea)' v-model.number="ruleForm.tableData[scope.$index].allocatedArea" placeholder="请输入分配任务" clearable></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="金额（万元）" style="width:100" align="center">
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'tableData.' + scope.$index + '.taskMoney'" :rules="rules.taskMoney">
                                                    <el-input :disabled="true" v-model="ruleForm.tableData[scope.$index].taskMoney" placeholder="请输入金额" clearable></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-form>
                        </div>
                        <div  class="bottom">
                            <div class="project-button "  @click="resetForm('ruleForm')">
                                <div class="project-button-text">取消</div>
                            </div>
                            <el-button type="primary" :loading="true" v-if="Loading" class="project-button project-button2">提交中</el-button>
                            <div class="project-button project-button2" @click="submitForm('ruleForm')" v-else>
                                <div class="project-button-text">提交</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
// import eventBus from '@/eventBus.js';
import SwProjectService from "../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.SwProjectService";
import FarmersMoneyNotAreaService from "../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.FarmersMoneyNotAreaService";
import eventBus from "../../eventBus";
import {gettime} from "../../js/gettime";
export default {
    data(){
        return{
            props: { multiple: true },
            Loading:false,
            labelText:'补助金额（元/亩）',//
            moduleData: [],//作业类型数组
            unitName: [],//下级单位数组
            ruleForm: {
                moduleSelection:[],
                multipleSelection: [],
                projectname: '',
                area:'',
                money:'',
                startTime:'',
                endTime:'',
                principalName:'',
                principalPhone:'',
                moduleData:[{
                    index:0,
                    workTypeId:"",
                    subsidyAmount:"",
                }],
                tableData:[{
                    index:0,
                    userId:"",
                    allocatedArea:"",
                    taskMoney:"",
                }],
                radio:"",
            },
            rules: {
                projectname: [
                    { required: true, message: '请输入项目名称', trigger: 'blur' },
                ],
                principalName: [
                    { required: true, message: '请输入负责人名称', trigger: 'blur' },
                ],
                principalPhone: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { type: 'number', message: '联系方式必须为数字值'},
                ],
                area: [
                    { required: true, message: '请输入项目总量', trigger: 'blur' },
                    { type: 'number', message: '项目总量必须为数字值'},
                ],
                money: [
                    { required: true, message: '请输入项目金额', trigger: 'blur' },
                    // { type: 'number', message: '项目金额必须为数字值'},
                ],
                startTime: [
                    {  required: true, message: '请选择开始时间', trigger: 'change' }
                ],
                endTime: [
                    {  required: true, message: '请选择结束时间', trigger: 'change' }
                ],
                // optionname: [
                //     { type: 'array', required: true, message: '请选择作业类型', trigger: 'change' }
                // ],
                radio: [
                    { required: true, message: '请选择是否全程托管', trigger: 'change' }
                ],
                workTypeId: [
                    { required: true, message: '请选择作业类型', trigger: 'change' }
                ],
                userId: [
                    { required: true, message: '请选择参与单位', trigger: 'change' }
                ],
                subsidyAmount: [
                    { required: true, message: '请输入每亩补助金额', trigger: 'change' },
                    { type: 'number', message: '金额必须为数字值'}
                ],
                allocatedArea: [
                    { required: true, message: '请输入分配任务', trigger: 'blur' },
                    { type: 'number', message: '必须为数字值'}
                ],
                taskMoney: [
                    { required: true, message: '请输入金额', trigger: 'blur' },
                ],
            },
            // // 开始时间选择器
            // pickerBeginDateBefore:{
            //     disabledDate: (time) => {
            //         let endDateVal = this.ruleForm.endTime;
            //         if (endDateVal) {
            //             return time.getTime() > new Date(endDateVal).getTime();
            //         }
            //     }
            // },
            // // 结束时间选择器
            // pickerBeginDateAfter:{
            //     disabledDate: (time) => {
            //         let beginDateVal = this.ruleForm.startTime;
            //         if (beginDateVal) {
            //             return (
            //                 time.getTime() < new Date(beginDateVal).getTime()
            //             );
            //         }
            //     }
            // },
            projectId:'',
            isAssign:false,
        }
    },
    mounted(){
        this.onload()
    },
    methods:{
        onload(){
            var that = this
            eventBus.$on('projectAdd',function () {
                //重置data数据
                // Object.assign(that.$data,that.$options.data())
                that.$refs['ruleForm'].resetFields();
                that.ruleForm.moduleData=[{
                    index:0,
                    workTypeId:"",
                    subsidyAmount:"",
                }]
                that.ruleForm.tableData=[{
                    index:0,
                    userId:"",
                    allocatedArea:"",
                    taskMoney:"",
                }]
                //作业类型清除选定
                for(var i=0;i<that.moduleData.length;i++){
                    delete that.moduleData[i].disabled
                }
                //下级单位清除选定
                for(var i=0;i<that.unitName.length;i++){
                    delete that.unitName[i].disabled
                }
            })
            eventBus.$on('projectEditor',function (id,update,assign) {
                that.projectId=id
                that.update=update
                that.isAssign=assign
                that.getProjectDetails(id)
            })
            that.moduleData=that.$store.state.modulesType
            that.getUnitName()
        },
        //获取项目详情
        getProjectDetails(id){
            SwProjectService.detail(id)
                .then(res=>{
                    var that = this
                    var data=res
                    that.ruleForm.projectname=res.projectName
                    that.ruleForm.area=res.projectArea
                    that.ruleForm.money=res.projectMoney.toFixed(2)
                    that.ruleForm.startTime=gettime.formatDate(res.startTime)
                    that.ruleForm.endTime=gettime.formatDate(res.endTime)
                    that.ruleForm.radio=res.hosting+''
                    that.ruleForm.principalName=res.principalName
                    that.ruleForm.principalPhone=Number(res.principalPhone)
                    // console.log(that.ruleForm)
                    for(var i=0;i<data.subProjectList.length;i++){
                        for(var j=0;j<that.unitName.length;j++){
                            if(data.subProjectList[i].userId==that.unitName[j].userId){
                                that.unitName[j].disabled=true
                            }
                        }
                        data.subProjectList[i].index=i
                        data.subProjectList[i].taskMoney=data.subProjectList[i].allocatedMoney.toFixed(2)
                        delete data.subProjectList[i].allocatedMoney
                        delete data.subProjectList[i].userName
                    }
                    for(var i=0;i<data.workTypeList.length;i++){
                        for(var j=0;j<that.moduleData.length;j++){
                            if(data.workTypeList[i].workTypeId==that.moduleData.id){
                                that.moduleData[j].disabled=true
                            }
                        }
                        data.workTypeList[i].index=i
                        delete data.workTypeList[i].typeName
                    }
                    that.ruleForm.moduleData=data.workTypeList
                    if(data.subProjectList.length==0){
                        that.ruleForm.tableData=[{
                            index:0,
                            userId:"",
                            allocatedArea:"",
                            taskMoney:"",
                        }]
                    }else{
                        that.ruleForm.tableData=data.subProjectList
                    }
                    // console.log(that.ruleForm)
                })
                .catch(err=>{
                    console.log(err)
                })
        },
        getN_module(){
            // 请求作业类型
            HomePageService.moduleType()
                .then((response)=>{
                    // console.log(response)
                    this.moduleData=response
                })
        },
        // 选择项目类型
        selectModule(val){
            var that = this
            // console.log('作业类型',val)
            if(val==132){
                that.labelText='补助金额（吨/元）'
            }else{
                that.labelText='补助金额（元/亩）'
            }
            //类型初始化
            for(var i=0;i<that.moduleData.length;i++){
                delete that.moduleData[i].disabled
            }
            for(var i=0;i<that.ruleForm.moduleData.length;i++){
                for(var j=0;j<that.moduleData.length;j++){
                    if(that.moduleData[j].id==that.ruleForm.moduleData[i].workTypeId){
                        that.moduleData[j].disabled=true
                        // that.ruleForm.moduleData[i].moduleName=that.modulesType[j].name
                    }
                }
            }
        },
        getUnitName(){
            // 请求参与单位
            var that=this
            SwProjectService.listLower()
                .then((response)=>{
                    // console.log(response)
                    that.unitName = response
                })
        },
        // 选择参与单位
        selectGetunitName(){
            var that = this
            // console.log(that.ruleForm.tableData[0].userId)
            //类型初始化
            for(var i=0;i<that.unitName.length;i++){
                delete that.unitName[i].disabled
            }
            for(var i=0;i<that.ruleForm.tableData.length;i++){
                for(var j=0;j<that.unitName.length;j++){
                    if(that.unitName[j].userId==that.ruleForm.tableData[i].userId){
                        that.unitName[j].disabled=true
                        // that.ruleForm2.tableData[i].moduleName=that.modulesType[j].name
                    }
                }
            }
        },
        // 时间开始选择器
        startTimeStatus:function(value){
            this.createDate = value
        },
        // 时间结束选择器
        endTimeStatus:function(value){

        },
        // 作业类型 单价 添加
        moduleAdd(){
            if(!this.isAssign){
                let row = {
                    index:this.ruleForm.moduleData.length,
                    workTypeId:"",
                    subsidyAmount:""
                }
                this.ruleForm.moduleData.push(row)
            }
        },
        // 单价值改变
        priceChange(index,val){
            console.log(index,val)
            if(this.title=='编辑项目'){
                for(var i=0;i< this.ruleForm.moduleData.length;i++){
                    if(index==this.ruleForm.moduleData[i].index){
                        this.ruleForm.moduleData[i].subsidyAmount=val
                    }
                }
            }
            var data=this.ruleForm.moduleData
            var money=0
            for(var j=0;j< data.length;j++){
                money+=Number(data[j].subsidyAmount)
            }
            this.ruleForm.money=((Number(money)*Number(this.ruleForm.area))/10000).toFixed(2)
            this.moneyChange()
        },
        //参与单位与任务面积、金额 添加
        add(){
            let row = {
                index:this.ruleForm.tableData.length,
                userId:"",
                allocatedArea:"",
                taskMoney:"",
                // type:""
            }
            this.ruleForm.tableData.push(row)
        },
        // 作业类型 单价 选中变化
        moduleSelectionChange(val){
            this.ruleForm.moduleSelection = val;
        },
        // 参与单位与任务面积、金额 选中变化
        handleSelectionChange(val) {
            this.ruleForm.multipleSelection = val;
        },
        //作业类型 单价 批量清除
        moduleDel(){
            var that = this
            if(!this.isAssign){
                // 拿到选中的数据；
                var val = that.ruleForm.moduleSelection
                // 所有数据
                var val2 = that.ruleForm.moduleData
                // 如果选中数据存在
                if (val) {
                    // 将选中数据遍历
                    val.forEach(function (item, index) {
                        // 遍历源数据
                        val2.forEach(function (itemI, indexI) {
                            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
                            if (item.index == itemI.index) {
                                val2.splice(indexI, 1)
                            }
                            //如果全部清除，需要保留一个初始数据
                            if(val2.length==0){
                                that.ruleForm.moduleData=[{
                                    index:0,
                                    workTypeId:"",
                                    subsidyAmount:"",
                                }]
                            }
                        })
                    })
                }
                val2.forEach(function (itemI, indexI) {
                    itemI.index = indexI
                })
                // 清除选中状态
                this.$refs.moduleMultipleTable.clearSelection()
            }
        },
        //参与单位与任务面积、金额 批量清除
        delArray () {
            var that = this
            // 拿到选中的数据；
            var val = that.ruleForm.multipleSelection
            // 所有数据
            var val2 = that.ruleForm.tableData
            // 如果选中数据存在
            if (val) {
                // 将选中数据遍历
                val.forEach(function (item, index) {
                    // 遍历源数据
                    val2.forEach(function (itemI, indexI) {
                        // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
                        if (item.index == itemI.index) {
                            val2.splice(indexI, 1)
                        }
                        //如果全部清除，需要保留一个初始数据
                        if(val2.length==0){
                            that.ruleForm.tableData=[{
                                index:0,
                                userId:"",
                                allocatedArea:"",
                                taskMoney:"",
                            }]
                        }
                    })
                })
            }
            val2.forEach(function (itemI, indexI) {
                itemI.index = indexI
            })
            // 清除选中状态
            this.$refs.multipleTable.clearSelection()
        },
        // 计算任务金额
        jstaskMoney(){
            for(var i=0;i<this.ruleForm.tableData.length;i++){
                var zArea = this.ruleForm.area
                var zMoney = this.ruleForm.money
                var zwArea = this.ruleForm.tableData[i].allocatedArea
                var zwMoney;
                if(zMoney=="" || zMoney==undefined){
                    // this.$message({
                    //     message: '请先输入项目金额',
                    //     type: 'warning'
                    // });
                    this.ruleForm.tableData[i].allocatedArea=""
                    var input = document.getElementById('areaInput')
                    input.focus()
                }else if(zArea&&zMoney&&zwArea){
                    // zwMoney = Math.floor(zwArea/zArea*zMoney*100)/100
                    zwMoney = (zwArea/zArea*zMoney*100)/100
                    zwMoney = zwMoney.toFixed(2)
                    this.ruleForm.tableData[i].taskMoney = zwMoney
                }
            }
        },
        // 任务面积不能大于总面积
        jsarea(index){
            var zarea=this.ruleForm.area
            var tableData=this.ruleForm.tableData
            var rwarea=0;
            for(var j=0;j<tableData.length;j++){
                rwarea+=Number(tableData[j].allocatedArea)
            }
            if (rwarea > zarea) {
                this.$message({
                    message: '任务不能大于总量',
                    type: 'warning'
                });
                for(var i=0;i<tableData.length;i++){
                    tableData[i].allocatedArea=""
                    tableData[i].taskMoney=""
                }
            }
        },
        // 任务面积输入框值发生变化时
        inputChange(index,val){
            console.log(index,val)
            if(this.update){
                for(var i=0; i<this.ruleForm.tableData.length;i++){
                    if(index==this.ruleForm.tableData[i].index){
                        this.ruleForm.tableData[i].allocatedArea=val
                    }
                }
            }
            this.jstaskMoney()
            this.jsarea()
        },
        // 总面积不能小于任务面积之和
        jszarea(){
            var zarea=this.ruleForm.area
            var tableData=this.ruleForm.tableData
            var rwarea=0;
            for(var i=0;i<tableData.length;i++){
                rwarea+=Number(tableData[i].allocatedArea)
            }
            if (rwarea > zarea) {
                this.$message({
                    message: '总量不能小于任务之和',
                    type: 'warning'
                });
                this.ruleForm.area=""
            }
        },
        // 项目面积输入框值发生变化
        areaChange(){
            var data=this.ruleForm.moduleData
            var money=0
            for(var i=0; i<data.length;i++){
                money+=Number(data[i].subsidyAmount)
            }
            this.ruleForm.money=((Number(money)*Number(this.ruleForm.area))/10000).toFixed(2)
            this.jszarea()
            this.jstaskMoney()
        },
        // 项目金额输入框值发生变化
        moneyChange(){
            this.jstaskMoney()
        },
        resetForm(){
            var that = this
            //重置data数据
            Object.assign(that.$data,that.$options.data())
            that.$store.state.add=''
        },
        submitForm(formName){
            var that=this
            //判断开始结束时间
            var start = new Date(that.ruleForm.startTime).getTime();
            var end = new Date(that.ruleForm.endTime).getTime();
            if (start >= end) {
                that.$message.warning('开始时间不能大于结束时间')
                return ;
            }
            //正在提交加载
            that.$refs[formName].validate((valid) => {

                if(valid){
                    that.Loading=true
                    var moduleDatas=that.ruleForm.moduleData
                    for(var i=0;i<moduleDatas.length;i++){
                        delete moduleDatas[i].index
                    }
                    var tableDatas=that.ruleForm.tableData
                    for(var i=0;i<tableDatas.length;i++){
                        delete tableDatas[i].index
                        delete tableDatas[i].taskMoney
                    }
                    //编辑
                    if(that.update){
                        console.log('update')
                        var data={
                            id:that.projectId,
                            projectName:that.ruleForm.projectname,
                            projectArea:that.ruleForm.area,
                            startTime:that.ruleForm.startTime,
                            endTime:that.ruleForm.endTime,
                            hosting:that.ruleForm.radio,
                            principalName:that.ruleForm.principalName,
                            principalPhone:that.ruleForm.principalPhone,
                            workTypeList:moduleDatas,
                            subProjectList:tableDatas,
                        }
                        SwProjectService.updateProject(data)
                            .then(response=>{
                                that.Loading=false
                                if(response){
                                    that.$message({
                                        type: 'success',
                                        message: "提交成功!"
                                    });
                                    that.$store.state.add=''
                                    that.$nextTick(function () {
                                        setTimeout(function () {
                                            eventBus.$emit('addProjectSuccess')
                                        },500)

                                    })
                                    that.$refs[formName].resetFields();
                                }else{
                                    that.$message.error("操作失败!");
                                }
                            })
                            .catch(error=>{
                                that.Loading=false
                                console.log(error)
                            })
                    }else if(that.isAssign){
                        //指派
                        var data={
                            projectId:that.projectId,
                            subProjectList:tableDatas,
                        }
                        SwProjectService.updateProjectAssign(data)
                            .then(response=>{
                                that.Loading=false
                                if(response){
                                    that.$message({
                                        type: 'success',
                                        message: "提交成功!"
                                    });
                                    that.$store.state.add=''
                                    that.$nextTick(function () {
                                        setTimeout(function () {
                                            eventBus.$emit('addProjectSuccess')
                                        },500)

                                    })
                                    that.$refs[formName].resetFields();
                                }else{
                                    that.$message.error("操作失败!");
                                }
                            })
                            .catch(error=>{
                                that.Loading=false
                                console.log(error)
                            })
                    }else {
                        //新增
                        var data={
                            projectName:that.ruleForm.projectname,
                            projectArea:that.ruleForm.area,
                            startTime:that.ruleForm.startTime,
                            endTime:that.ruleForm.endTime,
                            hosting:that.ruleForm.radio,
                            principalName:that.ruleForm.principalName,
                            principalPhone:that.ruleForm.principalPhone,
                            workTypeList:moduleDatas,
                            subProjectList:tableDatas,
                        }
                        console.log(that.ruleForm)
                        SwProjectService.addProject(data)
                            .then(response=>{
                                that.Loading=false
                                if(response){
                                    that.$message({
                                        type: 'success',
                                        message: "提交成功!"
                                    });
                                    that.$store.state.add=''
                                    that.$nextTick(function () {
                                        setTimeout(function () {
                                            eventBus.$emit('addProjectSuccess')
                                        },500)

                                    })
                                    that.$refs[formName].resetFields();
                                }else{
                                    that.$message.error("操作失败!");
                                }
                            })
                            .catch(error=>{
                                that.Loading=false
                                console.log(error)
                            })
                    }

                }else{
                    return
                }
            })

        },
        // 点击关闭
        close(){
            var that = this
            that.$store.state.details=''
            that.$store.state.add=''
            that.$store.state.list='centerBot'
            //重置data数据
            Object.assign(that.$data,that.$options.data())
        },
    },
    beforeDestroy() {
        var that = this
        eventBus.$off('projectAdd')
        eventBus.$off('projectEditor')
        //重置data数据
        Object.assign(that.$data,that.$options.data())
    }
}
</script>
<style lang="less">
@import '../../viewsStyle/project/projectAdd.less';
</style>